import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import config from "../../config";
import { PrimeReactProvider } from 'primereact/api';

function AddTeam() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const [formData, setFormData] = useState({
    title: '',
    position: '',
    featuredImage: null
  });

  const handleInputChange = (e) => {
    const { name, value, files } = e;
    setFormData((prevData) => ({
      ...prevData,
      [name]: files ? files : value
    }));
  };


  const handleAddLocation = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append('title', formData.title);
    data.append('position', formData.position);

    if (formData.featuredImage) {
      data.append('featuredImage', formData.featuredImage[0]);
    }

    try {
      const response = await axios.post(`${config.BASE_URL}/api/admin/add-team`, data, {
        withCredentials: true,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      if (response.status === 200) {
        const token = localStorage.getItem('token');
        if (token) {
          navigate('/admin/teams');
        } else {
          navigate('/admin/login');
        }
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to add Team');
    }
  };

  return (
    <PrimeReactProvider>
      <div className="dashboard admin_dashboard">
        <div className="container">
          <h1 className="dash_title">Add Team Member</h1>
          <div className="main-section">
            <div className="back_btn_wrap">
              <button className="back-btn" onClick={() => navigate(-1)}>Go Back</button>
            </div>
            <div className="main-inner add_project_main">
              <form onSubmit={handleAddLocation} encType="multipart/form-data">
                <div className="update_details_wrap">
                  <div className="form-group titleField">
                    <h2>Name</h2>
                    <input
                      type="text"
                      name="title"
                      value={formData.title}
                      onChange={(e) => handleInputChange(e.target)}
                      required
                    />
                  </div>

                  <div className="form-group titleField">
                    <h2>Position</h2>
                    <input
                      type="text"
                      name="position"
                      value={formData.position}
                      onChange={(e) => handleInputChange(e.target)}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <h2>Featured Image</h2>
                    <div className="form-group">
                      <div className="file-upload">
                        <input
                          type="file"
                          className="form-control"
                          name="featuredImage"
                          onChange={(e) => handleInputChange(e.target)}
                        />
                        <i className="fa fa-camera i-pic-upload"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="add_project">
                  <button type="submit">Add Team member</button>
                </div>
              </form>
              {error && <p className="error-message">{error}</p>}
            </div>
          </div>
        </div>
      </div>
    </PrimeReactProvider>
  );
}

export default AddTeam;
